import {Injectable} from "@angular/core";
import {AppConfigService} from "../services/appconfig.service";

@Injectable({
  providedIn: 'root'
})
export class PathStore {

  baseURL: string = ""
  baseURLPosizioni: string = ""
  baseURLProfile: string = ""
  baseURLConfiguration: string = ""
  posizioniUrlAreaPersonale: string = ""
  userProfileUrl: string = ""
  areaPagamentoUrl: string = ""
  serviziSpontaneiUrl: string = ""
  authority_auth_Url: string = ""
  posizioniAreaPersonaleUrl: string = ""
  posizioniPredeterminatiUrl: string = ""
  areaPagamentoStampaAvvisoUrl: string = ""
  areaPagamentoAggiungiAlCarrelloUrl: string = ""
  areaPagamentoIsMyPayUrl: string = ""
  posizioniStampaSpontaneoUrl: string = ""
  posizioniStampaRicevutaUrl: string = ""
  pagamentoAreaPersonaleUrl: string = ""
  areaPagamentoAnonimaUrl: string = ""
  posizioniServiceUrl: string = ""
  // [x]: paynow
  areaPagamentoGenericoAnonimoUrl: string = ""
  // TODO: F24 - communications & notifications
  messagesUrl: string = ""

  baseURLAuthority: string = ""
  authorityDomain: string = ""
  service: string = ""

  constructor(private appConfigService: AppConfigService) {
    this.baseURLPosizioni = this.appConfigService?.getConfig()?.settings?.apiServer.posizioniHost ?? ''
    this.baseURLProfile = this.appConfigService?.getConfig()?.settings?.apiServer.profileHost ?? ''
    this.baseURLConfiguration = this.appConfigService?.getConfig()?.settings?.apiServer.configurationHost ?? ''
    this.baseURLAuthority = this.appConfigService?.getConfig()?.settings?.apiServer.authorityUrl ?? ''
    this.authorityDomain = this.appConfigService?.getConfig()?.settings?.apiServer.authorityDomain ?? ''
    this.setAllUrls()
  }
  private setAllUrls() {
    this.posizioniUrlAreaPersonale = this.baseURLPosizioni + '/posizioniservice/areapersonale'
    this.posizioniServiceUrl = this.baseURLPosizioni + '/posizioniservice'
    this.posizioniPredeterminatiUrl = this.baseURLPosizioni + '/posizioniservice/ricercapredeterminati'
    this.posizioniStampaSpontaneoUrl = this.baseURLPosizioni + '/posizioniservice/ente'
    this.posizioniStampaRicevutaUrl = this.baseURLPosizioni + '/areapagamentoservice/ente'
    this.userProfileUrl = this.baseURLProfile + '/UserProfileService'
    this.areaPagamentoUrl = this.baseURLPosizioni + '/areapagamentoservice/areadipagamento'
    this.pagamentoAreaPersonaleUrl = this.areaPagamentoUrl + '/pagamento'
    this.areaPagamentoAnonimaUrl = this.baseURLPosizioni + '/areapagamentoservice/areadipagamentoanonimo'
    this.areaPagamentoStampaAvvisoUrl = this.areaPagamentoUrl + '/stampa/avviso'
    this.areaPagamentoAggiungiAlCarrelloUrl = this.areaPagamentoUrl + '/ente'
    this.areaPagamentoIsMyPayUrl = this.areaPagamentoAggiungiAlCarrelloUrl + '/ismypay' // ismypay/{codiceEnte}/{codiceServizio}
    this.authority_auth_Url = this.appConfigService?.getConfig()?.settings?.api?.authority_auth ?? ''
    this.serviziSpontaneiUrl = 'ServiziSpontanei'
    this.service = this.baseURLPosizioni + '/service'
    // [x]: paynow
    this.areaPagamentoGenericoAnonimoUrl = this.baseURLPosizioni + '/areapagamentoservice/ente/pagaOraGenericoAnonimo'
    // TODO: F24 - communications & notifications
    this.messagesUrl = this.baseURLPosizioni + '/communicationservice'
  }
}

// [HttpGet]
// [Route("communicationservice/notifiche/nuove")]
// public async Task<IActionResult> GetNuoveNotificheGenericheAsync()

// [HttpGet]
// [Route("communicationservice/notifiche/generiche")]
// public async Task<IActionResult> GetTutteNotificheGenericheAsync([FromQuery] int pageNumber = 1, [FromQuery] int pageSize = 10)

// [HttpPost]
// [Route("communicationservice/notifiche/mark-notification-read/{notificaId}")]
// public async Task<IActionResult> SegnaNotificaGenericaComeLettaAsync(Guid notificaId)

// [HttpGet]
// [Route("communicationservice/comunicazioni/nuove/{enteId}")]
// public async Task<IActionResult> GetNuoveComunicazioniPerEnteAsync(Guid enteId)

// [HttpGet]
// [Route("communicationservice/comunicazioni/nuove")]
// public async Task<IActionResult> GetNuoveComunicazioniGenericheAsync()

// [HttpGet]
// [Route("communicationservice/comunicazioni/generiche")]
// public async Task<IActionResult> GetTutteComunicazioniGenericheAsync([FromQuery] int pageNumber = 1, [FromQuery] int pageSize = 10)

// [HttpPost]
// [Route("communicationservice/comunicazioni/mark-communication-read/{comunicazioneId}")]
// public async Task<IActionResult> SegnaComunicazioneComeLettaAsync(Guid comunicazioneId)

// [HttpGet]
// [Route("communicationservice/comunicazioni/{enteId}")]
// public async Task<IActionResult> GetTutteComunicazioniPerEnteAsync(Guid enteId)
